import collapsedLogger from './collapsed-logger';
import isTrue from './is-true';

/*
 * Get all card brands from srcInfo object, active SRC networks
 * @param  {Array} srcInfoSdks active SRC networks from DCP portal
 * @return {Array} supportedCardBrandsFromSrcInfo - return an array of supported Card Brands
 */
const getCardBrandsFromSrcInfo = srcInfoSdks => {
  const supportedCardBrandsFromSrcInfo = [];
  Array.isArray(srcInfoSdks) &&
    srcInfoSdks.forEach(sdkInfo => {
      supportedCardBrandsFromSrcInfo.push(sdkInfo.cardBrand);
    });

  collapsedLogger('supportedCardBrandsFromSrcInfo => ', supportedCardBrandsFromSrcInfo);
  return supportedCardBrandsFromSrcInfo;
};

/*
 * If merchant profile supports only one card eg VISA, and merchant is enabled for FUT, should load all ext-SDKs
 * cardbrands coming through optimizely
 * @param  {obj} cardBrands - either merchantProfileBrands or buttonCardBrands
 * @param  {Array} srcInfoSdks - merchant supported networks
 * @param  {Array} vInitCardBrands - cardBrands receiving as part of vInit
 * @param  {Array} srcNetworks - srcNetworks receiving as part of meta data config
 * @param  {Boolean} futEnabled - futEnabled flag, indicates merchant is set for FUT(Friendly User Testing)
 * @param  {Boolean} isVsb - isVsb flag indicates merchant or PSP as VSB
 * @return {Array} supportedCardBrands - return an array of supported Card Brands
*/
//getSupportedCardBrands logic has modified to address VCO-14818/[F20305]
const getSupportedCardBrands = (
  cardBrands,
  srcInfoSdks,
  vInitCardBrands,
  srcNetworks,
  futEnabled = false,
  isVsb = false
) => {
  const supportedCardBrands = [];
  //For VSB use case maximum we can support cardBrands from srcNetworks
  if (isTrue(futEnabled)) {
    return vInitCardBrands.length
      ? cardBrands
      : isVsb
        ? srcNetworks
        : getCardBrandsFromSrcInfo(srcInfoSdks);
  }
  if (!isTrue(futEnabled)) {
    return cardBrands;
  }
  return supportedCardBrands;
};

export default getSupportedCardBrands;
